import { Row, Tabs, Col } from "antd";
import React from "react";
import { connect } from "react-redux";
import { setPropsMath } from "../../../redux/actions/appActions";
import SlotItem from "./SlotItem";
import Odometer from "react-odometerjs";
import "odometer/themes/odometer-theme-default.css";
import {
  getSlotsGames,
  getJackpots,
} from "../../../redux/actions/slotsActions";
import {
  jackpotConnect,
  jackpotDisconnect,
} from "../../../redux/actions/singnalrActions";
import { isMobile } from "react-device-detect";
import { AppConfig, Cookies } from "../../../helpers";
import { Images } from "../../../components";
import { JackpotLevel } from "../../../helpers/enums";
import { useMediaQuery } from "react-responsive";

const IsMobileView = ({ children }) => {
  const isMiddleScreenAndMobile = useMediaQuery({ maxWidth: 770 });
  return isMiddleScreenAndMobile ? children : null;
};
const IsDesktopAndMiddleScreen = ({ children }) => {
  const isDesktop = useMediaQuery({ minWidth: 770 });
  return isDesktop ? children : null;
};
const TabPane = Tabs.TabPane;

class SlotList extends React.Component {
  state = {
    selectedTab: window.location.search.includes('groupId=') ? window.location.search.split('groupId=')[1] : '0',
  };

  async componentDidMount() {
    const {
      getSlotsGames,
      setPropsMath,
      jackpotConnect,
      getJackpots,
    } = this.props;
    // template id for desktop is 1
    getSlotsGames(1);
    getJackpots();
    setPropsMath();

    jackpotConnect();
  }

  componentWillUnmount() {
    const { jackpotDisconnect } = this.props;
    jackpotDisconnect();
  }

  async componentDidUpdate(prevProps) {}

  onTabChange(key) {
    this.setState({ selectedTab: key });
  }

  render() {
    const {
      config,
      categories,
      slotsGames,
      jackpotBalances,
      winningMessage,
      jackpotImage,
    } = this.props;
    // old logic
    // const jackpotSize = window.innerHeight <= 580 ? "small" : "medium";
    // End of old logic
    const jackpotSize = "medium";
    let filteredSlotGames = [];
    slotsGames &&
      slotsGames
        .sort((a, b) => a.gameOrder < b.gameOrder)
        .map((row, i) => {
          if (this.state.selectedTab == "0") {
            filteredSlotGames.push(row);
          } else if (this.state.selectedTab == row.categoryId.toString()) {
            filteredSlotGames.push(row);
          }
        });
    return (
      categories && (
        <div className="items">
          <Tabs
            className="tabs-events fixed-height-tab"
            defaultActiveKey={
              this.state.selectedTab || categories[0].categoryId.toString()
            }
            onChange={(key) => {
              this.onTabChange(key);
            }}
          >
            {categories.map((item, i) => (
              <TabPane tab={item.categoryName} key={item.categoryId.toString()}>
                <Row gutter={16} align="middle" type="flex">
                  <Col
                    className="gutter-row"
                    xs={8 + 6}
                    sm={8 + 4}
                    md={8 + 2}
                    lg={12}
                    xl={12}
                  >
                    <div className="jackpots-main" style={{ height: "100%" }}>
                      <div
                        style={{ height: "90%", width: "100%" }}
                        className="gutter-box"
                      >
                        <img
                          className="main-jackpot-image slot-image"
                          alt="jackpots"
                          src={jackpotImage}
                        />
                      </div>
                      {/* {winningMessage && (
                        <div className="jackpots-text-win">
                          {winningMessage}
                        </div>
                      )} */}
                      <div className="jackpots-text">
                        {/* {jackpotBalances &&
                          jackpotBalances[JackpotLevel.Web] && (
                            <div className={`blue-plate-text header`}>
                              {" "}
                              {jackpotBalances[JackpotLevel.Web].jackpotName}
                            </div>
                          )} */}
                        <div
                          className={`odomemter-wrapper blue-${jackpotSize}`}
                        >
                          {winningMessage ? (
                            <div className="jackpots-text-win">
                              {winningMessage}
                            </div>
                          ) : (
                            <>
                              <div className="currency">
                                {jackpotBalances &&
                                jackpotBalances[JackpotLevel.Web]
                                  ? jackpotBalances[JackpotLevel.Web]
                                      .currencySymbol
                                  : "LD"}
                              </div>
                              <Odometer
                                value={
                                  jackpotBalances &&
                                  jackpotBalances[JackpotLevel.Web]
                                    ? jackpotBalances[JackpotLevel.Web]
                                        .jackpotAmount
                                    : 0
                                }
                                format="(,ddd).dd"
                                theme="default"
                              />
                            </>
                          )}
                        </div>
                        {!winningMessage && (
                          <div
                            className={`odomemter-wrapper usd-blue-${jackpotSize}`}
                          >
                            <div className="currency">$</div>
                            <Odometer
                              value={
                                jackpotBalances &&
                                jackpotBalances[JackpotLevel.Web]
                                  ? jackpotBalances[JackpotLevel.Web]
                                      .jackpotUsdValue
                                  : 0
                              }
                              format="(,ddd).dd"
                              theme="default"
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  </Col>
                  <IsDesktopAndMiddleScreen>
                    <Col
                      className="gutter-row"
                      xs={8 + 6}
                      sm={8 + 4}
                      md={8 + 2}
                      lg={12}
                      xl={12}
                    >
                      <Row className="additional-rows" gutter={16}>
                        {filteredSlotGames &&
                          filteredSlotGames.length > 0 &&
                          filteredSlotGames
                            .sort((a, b) => a.gameOrder < b.gameOrder)
                            .slice(0, 3)
                            .map((row, i) => {
                              let itemsInRow = config.slotsGamesRow;
                              return (
                                <SlotItem
                                  isJackPotNieghbor={true}
                                  {...this.props}
                                  key={
                                    row.gameId +
                                    `-${i}-${this.state.selectedTab}`
                                  }
                                  data={row}
                                />
                              );
                            })}
                      </Row>
                      <Row className="additional-rows" gutter={16}>
                        {filteredSlotGames &&
                          filteredSlotGames.length > 0 &&
                          filteredSlotGames
                            .sort((a, b) => a.gameOrder < b.gameOrder)
                            .slice(3, 6)
                            .map((row, i) => {
                              let itemsInRow = config.slotsGamesRow;
                              return (
                                <SlotItem
                                  isJackPotNieghbor={true}
                                  {...this.props}
                                  key={
                                    row.gameId +
                                    `-${i}-${this.state.selectedTab}`
                                  }
                                  data={row}
                                />
                              );
                            })}
                      </Row>
                    </Col>
                    <div className="additional-rows" style={{width:"100%"}}>
                      {filteredSlotGames &&
                        filteredSlotGames.length > 0 &&
                        filteredSlotGames
                          .sort((a, b) => a.gameOrder < b.gameOrder)
                          .slice(6)
                          .map((row, i) => {
                            let itemsInRow = config.slotsGamesRow;
                            return this.state.selectedTab !==
                              row.categoryId.toString() &&
                              this.state.selectedTab !== "0" ? null : (
                              <SlotItem
                                {...this.props}
                                key={
                                  row.gameId + `-${i}-${this.state.selectedTab}`
                                }
                                data={row}
                              />
                            );
                          })}
                    </div>
                  </IsDesktopAndMiddleScreen>
                  <IsMobileView>
                    <div className="mobile-view-list">
                      {slotsGames &&
                        slotsGames
                          .sort((a, b) => a.gameOrder < b.gameOrder)
                          .map((row, i) => {
                            let itemsInRow = config.slotsGamesRow;
                            return this.state.selectedTab !==
                              row.categoryId.toString() &&
                              this.state.selectedTab !== "0" ? null : (
                              <SlotItem
                                {...this.props}
                                key={
                                  row.gameId + `-${i}-${this.state.selectedTab}`
                                }
                                data={row}
                              />
                            );
                          })}
                    </div>
                  </IsMobileView>
                </Row>
              </TabPane>
            ))}
          </Tabs>
        </div>
      )
    );
  }
}

const mapStateToProps = (_, initialProps) => (state) => {
  return {
    slotsGames: state.slots.slotsGames,
    categories: state.slots.categories,
    config: state.slots.config,
    jackpotBalances: state.jackpot.jackpotBalances,
    winningMessage: state.jackpot.winningMessage,
    jackpotImage: state.general.configuration.jackpotImage,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    getSlotsGames: (templateId) => dispatch(getSlotsGames(templateId)),
    setPropsMath: () => dispatch(setPropsMath()),
    jackpotConnect: () => dispatch(jackpotConnect()),
    jackpotDisconnect: () => dispatch(jackpotDisconnect()),
    getJackpots: () => dispatch(getJackpots()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SlotList);
